import {Checkout, CheckoutStatus, PaymentOrderStatus} from "@irati/types"
import isStockAssignmentError from "@shared/checkout/utils/checkout/isStockAssignmentError"
import paymentService from "@irati/payments/services/Payments"
import checkoutService from "../../../services/checkout"

export enum CheckoutError {
  PaymentError = "Payment Error",
  StockAssignmentError = "Stock Assignment Error",
  RedemptionError = "Redemption Error",
  NotInError = "Not In Error",
  UnknownError = "Unknown Error"
}

export interface CheckoutErrorData {
  reason: CheckoutError,
  checkout?: Checkout
}

export default async function checkoutError(paymentOrderId: string, checkoutId: string): Promise<CheckoutErrorData> {
  try {
    const checkout = await checkoutService.getCheckout(checkoutId, {fetchPolicy: "network-only"})
    if (checkout.status === CheckoutStatus.Completed) {
      return {reason: CheckoutError.NotInError, checkout}
    }

    if (checkout.fullRedemptions[0] && isStockAssignmentError(checkout.fullRedemptions[0])) {
      return {reason: CheckoutError.StockAssignmentError, checkout}
    }

    const po = await paymentService.getPaymentOrder(paymentOrderId, {forceRefetch: true})
    if (po.status !== PaymentOrderStatus.Completed) {
      return {reason: CheckoutError.PaymentError, checkout}
    }

    if (!checkout.fullRedemptions[0]) {
      return {reason: CheckoutError.RedemptionError, checkout}
    }

    return {reason: CheckoutError.UnknownError, checkout}
  } catch (e) {
    return {reason: CheckoutError.UnknownError}
  }
}
